<template>
  <b-container>
    <h1 v-translate>Edit Service Quote</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <translate>The Service Quote has been updated</translate>
    </b-alert>
    <quote-services-create
      v-if="done === true"
      :quote-data="quoteData"
      :base-company="company"
      @quoteupdated="showAlert"
    />
  </b-container>
</template>

<script>
import QuoteServicesCreate from '@/components/QuoteServicesCreate'
export default {
  components: {
    QuoteServicesCreate
  },
  data() {
    return {
      quoteData: {},
      company: null,
      areaFrom: null,
      areaTo: null,
      done: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted() {
    this.fetchQuoteService()
  },
  methods: {
    fetchQuoteService() {
      this.$http.get(this.$appConfig.api.baseUrl + 'quote-services/' + this.$route.params.id, {params: {includes: ['company']}})
        .then(response => {
          this.quoteData = response.data
          this.done = true
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
